import React from 'react';
import { graphql } from 'gatsby';
import { navigate } from '@reach/router';
import { Detail, Seo } from 'components';
import { buildServiceSchema } from 'utils/serviceSchema';

const SITE_URL = 'https://www.nimax.ru';

export default ({
  data: {
    page: {
      frontmatter: { seo_title, full_title, title, redirect, tags, announce, og, schemaData, description },
      body
    }
  },
  location
}) => {
  if (redirect) {
    navigate(redirect);
  }

  const pageUrl = location ? `${SITE_URL}${location.pathname}` : undefined;
  const schemaObj = buildServiceSchema({ title, description, pageUrl, schemaData });

  return (
    <>
      <Seo title={seo_title || full_title || title} og={og} schema={schemaObj} description={description} />
      <Detail title={full_title || title} tags={tags ? tags.split(',').map(t => t.trim()) : []} announce={announce}>
        {body}
      </Detail>
    </>
  );
};

export const pageQuery = graphql`
  query($id: String!) {
    page: mdx(id: {eq: $id}) {
      frontmatter {
        title
        full_title
        seo_title
        redirect
        tags
        announce
        og
        description
        schemaData {
          organization
          serviceList {
            name
          }
          breadcrumbs {
            url
            name
          }
        }
      }
      body
    }
  }
`;
